import { render } from "./App.vue?vue&type=template&id=b26bf144"
const script = {}

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/Microfrontends/devices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__